var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOsmo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.564 6.95c-.284-1.098-1.2-2.196-2.847-3.417C24.395 2.559 22.992 2 21.873 2c-.223 0-.427.02-.63.062-.508.104-.956.476-1.24 1.036-.346.662-.428 1.553-.204 2.091.08.165.182.371.303.558a11.12 11.12 0 0 1-.878.496 11.794 11.794 0 0 0-4.185-.765C8.39 5.48 3 10.966 3 17.74 3 24.512 8.39 30 15.04 30s12.04-5.488 12.04-12.26c0-2.482-.727-4.792-1.974-6.722.099-.447.24-.918.408-1.397.285.084.57.126.854.126.753 0 1.403-.311 1.81-.87.407-.56.57-1.305.386-1.926zm-9.043.145a11.155 11.155 0 0 0 .062.028l-.06-.028zM3.672 17.74c.001-6.215 4.797-11.278 10.83-11.564C8.472 6.462 3.671 11.53 3.671 17.74c.001 6.393 5.091 11.576 11.37 11.576-6.284 0-11.369-5.177-11.369-11.576zm21.282-5.68a11.67 11.67 0 0 1 0 .004v-.003zM4.22 17.74v-.104h.003c.077-1.385 1.737-1.338 4.695-.994 1.363.166 3.234.27 5.308-.352 2.4-.746 4.495-.953 6.57-.787 2.788.241 4.903.934 5.018 2.133h.025c0 6.068-4.841 10.997-10.8 10.997-5.904 0-10.73-4.84-10.818-10.83l-.002-.063z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsmo);
export default __webpack_public_path__ + "static/media/OSMO.a43e5f8210e4e3583de3b9ee58d39122.svg";
export { ForwardRef as ReactComponent };